import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  createStyles,
  IconButton,
  LinearProgress,
  Modal,
  Slide,
  TableSortLabel,
  Theme,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import SortIcon from "@material-ui/icons/Sort";
import SortByAlphaIcon from "@material-ui/icons/SortByAlpha";
import { Pagination } from "@material-ui/lab";
import { withStyles } from "@material-ui/styles";
import { useAppDispatch, useAppSelector } from "app/hooks";
import BACKGROUND from "assets/img/bg_manager_student.png";
import NO_AVATAR from "assets/img/no_avatar.png";
import { useNavigate } from "react-router-dom";

import CloseIcon from "@material-ui/icons/Close";
import managerUserApi from "api/managerUser";
import axios, { AxiosResponse } from "axios";
import clsx from "clsx";
import EmptyComponent from "components/Empty";
import InputField from "components/FormFields/InputField";
import { BASE_URL, TOKEN } from "constants/config";
import { useConfirm } from "material-ui-confirm";
import { InfoUser } from "models/auth";
import { ListParams, ResponseStatus } from "models/common";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { dateTimeToFormatYYYY } from "utils/dateTimeFormat";
import * as XLSX from "xlsx";
import InputSearch from "../../../../components/InputSearch";
import {
  fetchUserList,
  selectFilterUserList,
  selectUserList,
  setFilterSearchDebounce,
  setFilterUserList,
} from "../ManagerAdmin/managerAdminSlice";
import CreateStudent from "./components/CreateStudent";
import useStyles from "./style";

export default function ListStudent() {
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 10px",
        backgroundColor: "#F8FAFC",
        color: "#0F172A",
        fontSize: 12,
        fontWeight: 700,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "2px solid #E2E8F0",
        top: "0 !important",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 14,
        },
      },
      body: {
        padding: "12px 10px",
        fontSize: 12,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "1px solid #F1F5F9",
        fontWeight: 500,
        color: "#334155",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const classes = useStyles({
    background: BACKGROUND,
  });
  const { t } = useTranslation();
  const filter = useAppSelector(selectFilterUserList);
  const [openModal, setOpenModal] = useState(false);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [staffIdUser, setStaffIdUser] = useState("");
  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseModalCreate = () => {
    setOpenModalCreate(false);
  };

  const userList = useAppSelector(selectUserList);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const containerRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const scrollContainer = containerRef.current?.closest("main");
    if (!scrollContainer) return;

    const handleScroll = () => {
      setIsSticky(scrollContainer.scrollTop > 180);
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, [userList]);
  const [sortType, setSortType] = useState(2);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { control, handleSubmit } = useForm();
  useEffect(() => {
    dispatch(
      fetchUserList({
        ...filter,
        role: "STUDENT",
      })
    );
  }, [dispatch, filter]);

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterUserList({
        ...filter,
        page: page - 1,
      })
    );
  };

  const handleSearchChange = (newFilter: ListParams) => {
    dispatch(setFilterSearchDebounce(newFilter));
  };

  const handleDeleteUser = async (user: InfoUser) => {
    confirm({
      title: (
        <Typography variant="h5" color="secondary">
          {t("delete.chuy")}
        </Typography>
      ),
      description: (
        <Typography variant="subtitle2">
          {t("delete.khiban")}{" "}
          <Typography variant="subtitle2" component="span" color="secondary">
            {t("delete.dongy")}
          </Typography>{" "}
          {t("delete.xoa")}
          <Typography variant="subtitle2" component="span" style={{ color: "#004673" }}>
            {" "}
            {user.name}
          </Typography>{" "}
          {t("delete.sexoatatcadulieu")}
        </Typography>
      ),
      confirmationText: <Button className={classes.btn_delete}>{t("delete.dongy")}</Button>,
      cancellationText: (
        <Button className={classes.btn_edit} style={{ margin: 0 }}>
          {t("delete.huybo")}
        </Button>
      ),
    })
      .then(async () => {
        const res: ResponseStatus = await managerUserApi.deleteUsers(user?.id);
        if (res.responseCode === "00") {
          toast.success(`${t("managerStudent.xoahocvienthanhcong")}`);
          dispatch(fetchUserList(filter));
        } else {
          toast.error(`${t("managerStudent.xoahocvienthatbai")}`);
          throw new Error("Delete user is failed");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSortType = (type: any) => {
    setSortType(type);
    dispatch(
      setFilterUserList({
        ...filter,
        sortType: type,
      })
    );
  };

  const handleResetPassword = (id: any) => {
    setOpenModal(true);
    setStaffIdUser(id);
  };

  const handleCreateUser = () => {
    setOpenModalCreate(true);
  };

  const handleSubmitForm = async (value: any) => {
    try {
      const res = await managerUserApi.resetPassword({
        username: staffIdUser,
        newPassword: value.newPassword,
      });
      if (res.responseCode === "00") {
        toast.success("Cập nhật mật khẩu thành công");
        setOpenModal(false);
      } else {
        toast.error(`Cập nhật mật khẩu thất bại`);
      }
    } catch (error) { }
  };

  const [openPreviewModal, setOpenPreviewModal] = useState<boolean>(false);
  const [previewUsers, setPreviewUsers] = useState<any[]>([]);
  const [previewFileName, setPreviewFileName] = useState<string>("");
  const [pendingFile, setPendingFile] = useState<any>(null);
  const [isLoadingPreview, setIsLoadingPreview] = useState<boolean>(false);
  const [isConfirmingImport, setIsConfirmingImport] = useState<boolean>(false);

  const parseExcelLocally = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook?.SheetNames?.[0];
          if (!firstSheetName) {
            resolve([]);
            return;
          }
          const worksheet = workbook.Sheets[firstSheetName];
          const rows: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });

          if (!rows || rows.length < 2) {
            resolve([]);
            return;
          }

          let staffIdCol = -1;
          let hoCol = -1;
          let tenCol = -1;
          let classCol = -1;

          const headerRow = rows[0].map((h: any) => String(h).toLowerCase().trim());

          headerRow.forEach((headerText: string, cellIdx: number) => {
            if (!headerText) return;
            if (staffIdCol === -1 && (headerText.includes("mssv") || headerText.includes("mã") || headerText.includes("staff") || headerText.includes("code") || headerText === "id")) {
              staffIdCol = cellIdx;
            } else if (classCol === -1 && (headerText.includes("lớp") || headerText.includes("class"))) {
              classCol = cellIdx;
            } else if (headerText.includes("họ và tên") || headerText === "họ tên" || headerText === "name" || headerText === "fullname") {
              hoCol = cellIdx;
              tenCol = -1;
            } else if (hoCol === -1 && (headerText === "họ" || headerText.includes("họ đệm") || headerText.includes("first"))) {
              hoCol = cellIdx;
            } else if (tenCol === -1 && (headerText === "tên" || headerText.includes("last"))) {
              tenCol = cellIdx;
            }
          });

          if (staffIdCol === -1) staffIdCol = 0;
          if (hoCol === -1) hoCol = 1;
          if (tenCol === -1 && hoCol !== 2) tenCol = 2;
          if (classCol === -1) classCol = tenCol !== -1 ? 3 : 2;

          const parsedUsers: any[] = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            if (!row) continue;

            const staffID = String(row[staffIdCol] || "").trim();
            if (!staffID) continue;

            const ho = hoCol !== -1 ? String(row[hoCol] || "").trim() : "";
            const ten = tenCol !== -1 ? String(row[tenCol] || "").trim() : "";
            const fullName = `${ho} ${ten}`.trim();
            const className = classCol !== -1 ? String(row[classCol] || "").trim() : "";

            parsedUsers.push({
              staffID,
              name: fullName,
              className,
            });
          }

          resolve(parsedUsers);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  const handleClosePreviewModal = () => {
    if (isConfirmingImport) return;
    setOpenPreviewModal(false);
    setPreviewUsers([]);
    setPreviewFileName("");
    setPendingFile(null);
    setImportProgress({ processed: 0, total: 0, success: 0, duplicated: 0, error: 0 });
  };

  const handleUpload = async (event: any) => {
    const fileExcel = event?.target?.files?.[0];
    if (!fileExcel) return;

    setPendingFile(fileExcel);
    setPreviewFileName(fileExcel.name);
    setIsLoadingPreview(true);
    setImportProgress({ processed: 0, total: 0, success: 0, duplicated: 0, error: 0 });

    try {
      const users = await parseExcelLocally(fileExcel);
      if (users && users.length > 0) {
        setPreviewUsers(users);
        setOpenPreviewModal(true);
      } else {
        toast.error("Không thể đọc danh sách học viên từ file Excel");
      }
    } catch (error) {
      toast.error("Lỗi khi đọc file Excel");
    } finally {
      setIsLoadingPreview(false);
      event.target.value = "";
    }
  };

  const tableContainerRef = useRef<HTMLDivElement>(null);

  const [importProgress, setImportProgress] = useState<{ processed: number; total: number; success: number; duplicated: number; error: number }>({
    processed: 0,
    total: 0,
    success: 0,
    duplicated: 0,
    error: 0,
  });

  const BATCH_SIZE = 25;

  const handleConfirmImport = async () => {
    if (!previewUsers || previewUsers.length === 0) return;

    const token = localStorage.getItem(TOKEN);
    setIsConfirmingImport(true);

    let currentUsers = previewUsers.map((u) => ({ ...u, status: u.status || "pending" }));
    setPreviewUsers(currentUsers);

    const total = currentUsers.length;
    let successCount = 0;
    let duplicatedCount = 0;
    let errorCount = 0;
    let processedCount = 0;

    setImportProgress({ processed: 0, total, success: 0, duplicated: 0, error: 0 });

    for (let i = 0; i < total; i += BATCH_SIZE) {
      const batchIndices: number[] = [];
      for (let j = i; j < Math.min(i + BATCH_SIZE, total); j++) {
        batchIndices.push(j);
      }

      currentUsers = currentUsers.map((u, idx) =>
        batchIndices.includes(idx) ? { ...u, status: "loading" } : u
      );
      setPreviewUsers([...currentUsers]);

      // Auto-scroll table to first row of current batch
      if (i > 0) {
        setTimeout(() => {
          const rowEl = document.getElementById(`preview-row-${i}`);
          if (rowEl) {
            rowEl.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 50);
      }

      const requestedUserList = batchIndices.map((idx) => ({
        staffID: currentUsers[idx].staffID,
        name: currentUsers[idx].name,
        className: currentUsers[idx].className || "",
        isAdmin: false,
      }));

      try {
        const res: AxiosResponse = await axios({
          method: "POST",
          url: `${BASE_URL}/user/importUserBatch`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          data: {
            requestedUserList: requestedUserList,
          },
        });

        const isSuccessResponse = (res?.data?.responseCode === "00" || res?.data?.responseCode === 200 || !res?.data?.responseCode) && res?.data?.createdUserList !== undefined;

        if (!isSuccessResponse) {
          currentUsers = currentUsers.map((u, idx) => {
            if (!batchIndices.includes(idx)) return u;
            errorCount++;
            return { ...u, status: "error" };
          });
        } else {
          const createdList = res?.data?.createdUserList || [];
          const failedList = res?.data?.failedUserList || [];

          const createdMap = new Map<string, string>();
          createdList.forEach((item: any) => {
            const sId = item.staffId || item.staffID;
            if (sId) {
              createdMap.set(String(sId).trim(), item.responseDescription || "");
            }
          });

          const failedSet = new Set<string>();
          failedList.forEach((item: any) => {
            const sId = item.staffId || item.staffID;
            if (sId) {
              failedSet.add(String(sId).trim());
            }
          });

          currentUsers = currentUsers.map((u, idx) => {
            if (!batchIndices.includes(idx)) return u;
            const sId = String(u.staffID).trim();
            if (failedSet.has(sId)) {
              errorCount++;
              return { ...u, status: "error" };
            }
            if (createdMap.has(sId)) {
              const desc = createdMap.get(sId);
              if (desc === "Duplicated" || desc?.toLowerCase().includes("dup")) {
                duplicatedCount++;
                return { ...u, status: "duplicated" };
              } else {
                successCount++;
                return { ...u, status: "success" };
              }
            }
            errorCount++;
            return { ...u, status: "error" };
          });
        }
      } catch (err) {
        currentUsers = currentUsers.map((u, idx) => {
          if (!batchIndices.includes(idx)) return u;
          errorCount++;
          return { ...u, status: "error" };
        });
      }

      processedCount += batchIndices.length;
      setImportProgress({
        processed: processedCount,
        total,
        success: successCount,
        duplicated: duplicatedCount,
        error: errorCount,
      });

      setPreviewUsers([...currentUsers]);
      await new Promise((resolve) => setTimeout(resolve, 80));
    }

    setIsConfirmingImport(false);
    toast.success(
      `Tải lên hoàn tất! Tạo mới: ${successCount}, Đã có sẵn: ${duplicatedCount}, Lỗi: ${errorCount}`
    );
    dispatch(fetchUserList(filter));
  };

  const renderStatusChip = (status?: string) => {
    switch (status) {
      case "loading":
        return (
          <Box display="flex" alignItems="center" style={{ gap: 6 }}>
            <CircularProgress size={14} color="primary" />
            <Typography variant="caption" style={{ color: "#1976d2", fontWeight: 600 }}>
              Đang tải...
            </Typography>
          </Box>
        );
      case "success":
        return (
          <Chip
            label="Thành công"
            size="small"
            style={{ backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600, fontSize: "0.75rem" }}
          />
        );
      case "duplicated":
        return (
          <Chip
            label="Đã có sẵn"
            size="small"
            style={{ backgroundColor: "#fff3e0", color: "#e65100", fontWeight: 600, fontSize: "0.75rem" }}
          />
        );
      case "error":
        return (
          <Chip
            label="Thất bại"
            size="small"
            style={{ backgroundColor: "#ffebee", color: "#c62828", fontWeight: 600, fontSize: "0.75rem" }}
          />
        );
      default:
        return (
          <Chip
            label="Chờ xử lý"
            size="small"
            variant="outlined"
            style={{ color: "#757575", borderColor: "#bdbdbd", fontSize: "0.75rem" }}
          />
        );
    }
  };

  return (
    <div ref={containerRef} className={classes.root}>
      <Box>
      <Box className={classes.background}>
        <Box className={classes.header}>
          <Box className={classes.header_title}>
            <Typography variant="subtitle2"> {t("managerStudent.danhsachhocvien")}</Typography>
            <Box>
              {sortType === 2 ? (
                <Tooltip title="Sort by name">
                  <SortByAlphaIcon onClick={() => handleSortType(1)} />
                </Tooltip>
              ) : (
                <Tooltip title="Sort by date">
                  <SortIcon onClick={() => handleSortType(2)} />
                </Tooltip>
              )}
            </Box>
          </Box>
          <label htmlFor="upload_file" className={classes.btn_upload}>
            {t("button.uploadfile")}
          </label>
          <input
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8ent.spreadsheetml.sheet"
            id="upload_file"
            multiple
            type="file"
            name="file"
            onChange={handleUpload}
            style={{ display: "none" }}
          />

        </Box>
      </Box>

      <Box className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
        <Box style={{ width: isMobile ? "100%" : 320 }}>
          <InputSearch
            filter={filter}
            onSearchChange={handleSearchChange}
            label={t("managerStudent.timkiemhocvientheoten")}
          />
        </Box>
        <Button
          className={classes.btn_create}
          style={{ width: isMobile ? "100%" : "auto" }}
          onClick={handleCreateUser}
        >
          Thêm mới
        </Button>
      </Box>
      {
        userList.content.length > 0 ? (
          <Box>
            <TableContainer component={Paper} className={classes.container}>
              <Table
                stickyHeader
              // style={{minWidth: 1400}}
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" width="70px">
                      {t("stt")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="250px">
                      <TableSortLabel
                        active={sortType === 1}
                        direction="asc"
                        onClick={() => handleSortType(1)}
                      >
                        {t("admin.tenhocvien")}
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" width="130px">
                      {t("admin.manhanvien")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="150px">
                      {t("admin.class")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="160px">
                      <TableSortLabel
                        active={sortType === 2}
                        direction="desc"
                        onClick={() => handleSortType(2)}
                      >
                        Ngày tạo
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" width="350px">
                      <Typography variant="subtitle1">{t("thaotac")}</Typography>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userList.content.map((user, index) => (
                    <TableRow
                      key={user.id}
                      className={classes.tableRow}
                      onClick={() => navigate(`/admin/manager-student/detail/${user?.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <StyledTableCell align="center" component="th" scope="user">
                        {userList.size * userList.number + index + 1}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          width="100%"
                          margin="0 auto"
                        >
                          <Box width="30%">
                            <img
                              src={user.profileImageUrl || NO_AVATAR}
                              alt="avatar"
                              className={classes.avatar}
                            />
                          </Box>
                          <Typography variant="subtitle2" className={classes.name}>
                            {user.name}
                          </Typography>
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell align="center" component="th" scope="user">
                        {user.staffId}
                      </StyledTableCell>
                      <StyledTableCell align="center" component="th" scope="user">
                        {user?.class?.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {user.createdAt ? dateTimeToFormatYYYY(user.createdAt) : "---"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Button
                          className={classes.btn_delete}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteUser(user);
                          }}
                        >
                          {t("button.delete")}
                        </Button>
                        <Button
                          className={classes.btn_edit}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/admin/manager-student/edit/${user?.id}`, {
                              state: {
                                infoUser: user,
                              },
                            });
                          }}
                        >
                          {t("button.edit")}
                        </Button>
                        <Button
                          className={classes.btn_edit}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleResetPassword(user.staffId);
                          }}
                        >
                          Đặt lại MK
                        </Button>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Mobile View: ListView */}
            {isMobile && (
              <Box className={classes.mobileListView}>
                {userList.content.map((user, index) => (
                  <Box
                    key={user.id}
                    className={classes.mobileCard}
                    onClick={() => navigate(`/admin/manager-student/detail/${user?.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Card Header: Avatar & Name */}
                    <Box className={classes.mobileCardHeader}>
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <img
                          src={user.profileImageUrl || NO_AVATAR}
                          alt="avatar"
                          className={classes.mobileAvatar}
                        />
                        <Box>
                          <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0F172A" }}>
                            {user.name}
                          </Typography>
                          <Typography variant="caption" style={{ color: "#64748B" }}>
                            STT: {userList.size * userList.number + index + 1}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Card Body: Info group */}
                    <Box className={classes.mobileCardBody}>
                      <Box className={classes.mobileCardRow}>
                        <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                          MÃ NHÂN VIÊN
                        </Typography>
                        <Chip
                          label={user.staffId || "---"}
                          size="small"
                          style={{
                            backgroundColor: "#E2E8F0",
                            color: "#334155",
                            fontWeight: 700,
                            borderRadius: 6,
                          }}
                        />
                      </Box>

                      <Box className={classes.mobileCardRow}>
                        <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                          LỚP HỌC
                        </Typography>
                        <Chip
                          label={user?.class?.name || "Chưa xếp lớp"}
                          size="small"
                          style={{
                            backgroundColor: "#E0F2FE",
                            color: "#0369A1",
                            fontWeight: 700,
                            borderRadius: 6,
                          }}
                        />
                      </Box>

                      <Box className={classes.mobileCardRow}>
                        <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                          NGÀY TẠO
                        </Typography>
                        <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                          {user.createdAt ? dateTimeToFormatYYYY(user.createdAt) : "---"}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Card Actions: Reset password, Edit, Delete */}
                    <Box className={classes.mobileCardActions}>
                      <Button
                        className={classes.btn_edit}
                        style={{ margin: 0 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleResetPassword(user.staffId);
                        }}
                      >
                        Đặt lại MK
                      </Button>

                      <Button
                        className={classes.btn_edit}
                        style={{ margin: 0 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/admin/manager-student/edit/${user?.id}`, {
                            state: {
                              infoUser: user,
                            },
                          });
                        }}
                      >
                        Sửa
                      </Button>
                      <Button
                        className={classes.btn_delete}
                        style={{ margin: 0 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteUser(user);
                        }}
                      >
                        Xóa
                      </Button>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            {userList.totalPages > 1 && (
              <Box className={classes.paginationContainer}>
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                  {t("managerStudent.tonghocvien")}: {userList.totalElements}
                </Typography>
                <Pagination
                  count={Math.ceil(userList.totalElements / userList.size)}
                  page={userList.number + 1}
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                  size={isMobile ? "small" : "medium"}
                  siblingCount={isMobile ? 0 : 1}
                  onChange={(e, page) => handleChangePage(page)}
                />
              </Box>
            )}
          </Box>
        ) : (
          <EmptyComponent />
        )
      }

      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        closeAfterTransition
        className={classes.root_modal}
      >
        <Slide direction="up" in={openModal}>
          <Box className={classes.modal__container}>
            <Box className={classes.modal__header}>
              <div></div>
              <Typography variant="subtitle2">{"Đặt mật khẩu mới"}</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <form onSubmit={handleSubmit(handleSubmitForm)} style={{ padding: "10px 20px" }}>
              <InputField
                name="newPassword"
                label={"Nhập mật khẩu mới"}
                control={control}
                borderRadius="10px"
              />

              <Box textAlign="center">
                <Button type="submit" className={classes.form__button}>
                  {t("button.update")}
                </Button>
              </Box>
            </form>
          </Box>
        </Slide>
      </Modal>

      <Modal
        open={openModalCreate}
        onClose={handleCloseModalCreate}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        closeAfterTransition
        className={classes.root_modal}
      >
        <Slide direction="up" in={openModalCreate}>
          <Box className={classes.modal__create__container} style={{ maxWidth: 640, borderRadius: 24, overflow: "hidden", border: "1px solid #E2E8F0", boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25)" }}>
            <Box className={classes.modal__header} style={{ background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)", color: "#FFFFFF", padding: "18px 24px" }}>
              <Box style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <PersonAddIcon style={{ color: "#818CF8", fontSize: 24 }} />
                <Typography variant="h6" style={{ fontWeight: 800, color: "#FFFFFF", fontSize: "1.125rem" }}>
                  Thêm mới học viên
                </Typography>
              </Box>
              <IconButton onClick={handleCloseModalCreate} style={{ color: "rgba(255, 255, 255, 0.7)" }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <CreateStudent handleClose={handleCloseModalCreate} />
          </Box>
        </Slide>
      </Modal>

      <Modal
        open={openPreviewModal}
        onClose={handleClosePreviewModal}
        closeAfterTransition
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Slide direction="up" in={openPreviewModal}>
          <Box className={classes.modal__create__container} style={{ maxWidth: 950, width: "95%", height: "85vh", margin: 0, marginTop: 0, display: "flex", flexDirection: "column" }}>
            <Box className={classes.modal__header}>
              <div style={{ width: 40 }}></div>
              <Typography variant="h6" style={{ fontWeight: 600, color: "#111" }}>
                Xem trước danh sách học viên ({previewUsers.length})
              </Typography>
              <IconButton onClick={handleClosePreviewModal}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box style={{ padding: "16px 24px", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
              <Box style={{ marginBottom: 14 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginBottom: 6 }}>
                  <Typography variant="body2" style={{ color: "#555", fontSize: "0.95rem" }}>
                    File: <strong style={{ color: "#1976d2" }}>{previewFileName}</strong> | Tổng số học viên: <strong style={{ color: "#111" }}>{previewUsers.length}</strong>
                  </Typography>

                  {isConfirmingImport && (
                    <Typography variant="caption" style={{ fontWeight: 600, color: "#1976d2" }}>
                      Đã xử lý {importProgress.processed}/{importProgress.total} ({Math.round((importProgress.processed / importProgress.total) * 100)}%) - Batch 25 học viên
                    </Typography>
                  )}
                </Box>

                {isConfirmingImport && (
                  <LinearProgress
                    variant="determinate"
                    value={importProgress.total > 0 ? (importProgress.processed / importProgress.total) * 100 : 0}
                    style={{ height: 6, borderRadius: 3, marginBottom: 10 }}
                  />
                )}

                {(importProgress.processed > 0 || isConfirmingImport) && (
                  <Box display="flex" style={{ gap: 10, marginTop: 4 }}>
                    <Chip label={`Tạo mới: ${importProgress.success}`} size="small" style={{ backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: 600 }} />
                    <Chip label={`Đã có sẵn: ${importProgress.duplicated}`} size="small" style={{ backgroundColor: "#fff3e0", color: "#e65100", fontWeight: 600 }} />
                    <Chip label={`Lỗi: ${importProgress.error}`} size="small" style={{ backgroundColor: "#ffebee", color: "#c62828", fontWeight: 600 }} />
                  </Box>
                )}
              </Box>

              <TableContainer ref={tableContainerRef} component={Paper} style={{ flex: 1, overflowY: "auto", borderRadius: 8, border: "1px solid #e0e0e0" }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold", backgroundColor: "#f5f5f5", width: 50 }}>STT</TableCell>
                      <TableCell style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>Mã học viên / MSSV</TableCell>
                      <TableCell style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>Họ và tên</TableCell>
                      <TableCell style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>Lớp</TableCell>
                      <TableCell style={{ fontWeight: "bold", backgroundColor: "#f5f5f5", width: 140 }}>Trạng thái</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {previewUsers.map((user: any, idx: number) => (
                      <TableRow key={idx} id={`preview-row-${idx}`} hover style={{ backgroundColor: user.status === "loading" ? "#f0f7ff" : "inherit" }}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: 600, color: "#1976d2" }}>{user.staffID}</TableCell>
                        <TableCell style={{ fontWeight: 500 }}>{user.name}</TableCell>
                        <TableCell>{user.className || "Chưa xếp lớp"}</TableCell>
                        <TableCell>{renderStatusChip(user.status)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box display="flex" justifyContent="flex-end" style={{ gap: 12, marginTop: 16 }}>
                <Button
                  variant="outlined"
                  onClick={handleClosePreviewModal}
                  disabled={isConfirmingImport}
                  style={{ borderRadius: 8, padding: "8px 20px" }}
                >
                  {importProgress.processed > 0 ? "Đóng" : "Hủy"}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmImport}
                  disabled={isConfirmingImport || previewUsers.length === 0 || importProgress.processed === importProgress.total && importProgress.total > 0}
                  style={{ borderRadius: 8, padding: "8px 24px", backgroundColor: "#1976d2", minWidth: 220 }}
                >
                  {isConfirmingImport ? (
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      <CircularProgress size={20} style={{ color: "#fff" }} />
                      <Typography variant="body2" style={{ color: "#fff", fontWeight: 600 }}>
                        Đang tạo ({importProgress.processed}/{importProgress.total})...
                      </Typography>
                    </Box>
                  ) : importProgress.processed === importProgress.total && importProgress.total > 0 ? (
                    "Đã tải lên xong"
                  ) : (
                    `Xác nhận tải lên (${previewUsers.length} học viên)`
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        </Slide>
      </Modal>

      <Backdrop open={isLoadingPreview} style={{ zIndex: 9999, color: "#fff", flexDirection: "column", gap: 16 }}>
        <CircularProgress size={60} style={{ color: "#fff" }} />
        <Typography variant="h6">Đang đọc dữ liệu từ file Excel, vui lòng chờ...</Typography>
      </Backdrop>
      </Box>
    </div>
  );
}
